/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetReviews200ResponseAllOfData } from './GetReviews200ResponseAllOfData';
import {
    GetReviews200ResponseAllOfDataFromJSON,
    GetReviews200ResponseAllOfDataFromJSONTyped,
    GetReviews200ResponseAllOfDataToJSON,
} from './GetReviews200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetReviews200ResponseAllOf
 */
export interface GetReviews200ResponseAllOf {
    /**
     * 
     * @type {GetReviews200ResponseAllOfData}
     * @memberof GetReviews200ResponseAllOf
     */
    data: GetReviews200ResponseAllOfData;
}

/**
 * Check if a given object implements the GetReviews200ResponseAllOf interface.
 */
export function instanceOfGetReviews200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetReviews200ResponseAllOfFromJSON(json: any): GetReviews200ResponseAllOf {
    return GetReviews200ResponseAllOfFromJSONTyped(json, false);
}

export function GetReviews200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReviews200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetReviews200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetReviews200ResponseAllOfToJSON(value?: GetReviews200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetReviews200ResponseAllOfDataToJSON(value.data),
    };
}

